var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.488,
    height: 19.601,
    viewBox: "0 0 19.488 19.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.8,19.6H3l.532-4.172H0V11.816H3.976l.476-4.032H.924V4.172H4.9L5.432,0H9.24L8.708,4.172h3.443L12.684,0h3.808L15.96,4.172h3.528V7.784H15.512l-.476,4.032h3.5v3.612H14.588L14.056,19.6H10.248l.532-4.172H7.336L6.8,19.6ZM8.26,7.784l-.476,4.032h3.444L11.7,7.784H8.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHashtag);
export default __webpack_public_path__ + "static/media/icon-hashtag.ae9006a057ffc6d808d6119a705eb56a.svg";
export { ForwardRef as ReactComponent };